import React from 'react';
import { QdsStandaloneLink } from '@quartzds/core-react';

type Props = {
    className?: string;
    icon?: string;
    href?: string;
    onClick?: (event: React.MouseEvent) => void;
};

export const CustomLinkLeftArrow: React.FC<Props> = ({
    className,
    children,
    href,
    ...otherProps
}) => (
  <QdsStandaloneLink
      className={className}
      size='standard' 
      importance='standard'
      href={href}
      iconName='chevron-left'
      {...otherProps}
    >
      {children}
    </QdsStandaloneLink> 
)
